var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGreenSuccess = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5485 10.9838C28.011 8.33978 24.4434 6.69233 20.5001 6.69233C12.8141 6.69233 6.56973 12.9367 6.56973 20.6227C6.56973 28.3087 12.8141 34.553 20.5001 34.553C28.1861 34.553 34.4304 28.3087 34.4304 20.6227C34.4304 17.6229 33.4778 14.8427 31.8598 12.5676L19.44 24.6227L12.5 17.9301L13.9588 16.4891L19.44 21.7671L30.5485 10.9838ZM32.0378 9.53814C29.1264 6.50841 25.0332 4.62268 20.5001 4.62268C11.6642 4.62268 4.5 11.7869 4.5 20.6227C4.5 29.4585 11.6642 36.6227 20.5001 36.6227C29.3359 36.6227 36.5 29.4585 36.5 20.6227C36.5 17.0589 35.3346 13.7671 33.3641 11.1076L36.5 8.06374L35.0412 6.62268L32.0378 9.53814Z",
    fill: "#00EC25"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGreenSuccess);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/GreenSuccess.648b2ec062b3e10b7864d8d3073447d3.svg";